import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * Resolve a media src for use in <img>/<a>. The backend returns upload paths as
 * relative "/api/uploads/{id}" — a bare <img src> would resolve those against
 * the FRONTEND origin (broken on Railway, where frontend and backend are
 * separate services). Prefix them with the bare BACKEND_URL (which does NOT
 * include /api, so we avoid "/api/api/"). Absolute (http/https), blob: and
 * data: URLs are returned untouched, so local previews keep working.
 */
export function mediaUrl(src) {
  if (!src) return src;
  if (/^(https?:|blob:|data:)/i.test(src)) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}

export default api;
